<div class="flex-column h-100">
  <div class="configuration-wizard-header flex-column">
    <h5
      class="odx-title-5"
      i18n="@@patientMonitorConfiguration.selectProductFamily.header"
      data-testid="patientMonitorConfiguration.selectProductFamily.header"
    >
      {{ title }}
    </h5>
    <form [formGroup]="additionalFilterForm">
      <div odxLayout="flex gap-small" class="filters">
        @if (filter1Options$ | async; as filter1Options) {
          @if (filter1Options.length > 0) {
            <odx-form-field [label]="filter1Label ?? filter1DefaultLabel">
              <odx-select
                odxFormFieldControl
                formControlName="filter1"
                multiple
                i18n-placeholder="@@optionConfiguration.filter1.placeholder"
                placeholder="Kein Filter"
              >
                @for (value of filter1Options | odxAutocompleteSearchFilter; track trackFilterOption(value, $index)) {
                  <odx-select-option [value]="value">{{ value }}</odx-select-option>
                }
                <input
                  [placeholder]="filter1InputPlaceholder ?? filter1DefaultInputPlaceholder"
                  odxSelectSearchField="Kein Ergebnis"
                  i18n-odxSelectSearchField="@@optionConfiguration.filter1.search.noResult"
                />
              </odx-select>
            </odx-form-field>
          }
        }

        @if (filter2Options$ | async; as filter2Options) {
          @if (filter2Options.length > 0) {
            <odx-form-field [label]="filter2Label ?? filter2DefaultLabel">
              <odx-select
                odxFormFieldControl
                formControlName="filter2"
                multiple
                i18n-placeholder="@@optionConfiguration.filter2.placeholder"
                placeholder="Kein Filter"
              >
                @for (value of filter2Options | odxAutocompleteSearchFilter; track trackFilterOption(value, $index)) {
                  <odx-select-option [value]="value">{{ value }}</odx-select-option>
                }
                <input
                  [placeholder]="filter2InputPlaceholder ?? filter2DefaultInputPlaceholder"
                  odxSelectSearchField="Kein Ergebnis"
                  i18n-odxSelectSearchField="@@optionConfiguration.filter2.search.noResult"
                />
              </odx-select>
            </odx-form-field>
          }
        }
      </div>
    </form>

    <app-filter-product (searchEvent)="search($event)"></app-filter-product>
  </div>

  <odx-content-box class="flex-column flex-scroll" odxLayout="flex">
    @if (step?.options) {
      @if (filteredOptionDisplays$ | async; as filteredOptionDisplays) {
        @if (filteredOptionDisplays.length > 0) {
          <form
            [formGroup]="
              step!.stepSelectionType === StepSelectionType.PICK0TON || step!.stepSelectionType === StepSelectionType.PICK1TON
                ? optionFormMultiple
                : optionFormSingle
            "
            class="h-100"
          >
            <odx-radio-group
              [formControlName]="
                step!.stepSelectionType === StepSelectionType.PICK0TON || step!.stepSelectionType === StepSelectionType.PICK1TON
                  ? 'selectedOptionMultiple'
                  : 'selectedOptionSingle'
              "
              class="h-100"
            >
              <div odxLayout="grid 3@desktop 6@tablet 12@phone" class="w-100 mb-36">
                @for (option of filteredOptionDisplays; track trackOptionDisplay(option)) {
                  @if (
                    hasQuantities ||
                    step!.stepSelectionType === StepSelectionType.PICK0TON ||
                    step!.stepSelectionType === StepSelectionType.PICK1TON
                  ) {
                    <app-monitoring-option-card-with-quantity
                      [optionData]="option"
                      [quantity]="getSelectedQuantity(option.option)"
                      [minValue]="option.option.quantityMin"
                      [maxValue]="option.option.quantityMax"
                      [selectionMode]="step!.stepSelectionType"
                      [category]="category"
                      [categoryLabel]="categoryLabel"
                      [isSelectedInput]="isSelected(option)"
                      [validationInvalid]="isValidationInvalid"
                      (quantityChanged)="updateQuantityForOption(option, $event)"
                      (select$)="select(option)"
                    />
                  } @else {
                    <app-monitoring-option-card
                      [option]="option"
                      [isSelected]="isSelected(option)"
                      [selectionMode]="step!.stepSelectionType"
                      [category]="category"
                      [categoryLabel]="categoryLabel"
                      (click)="select(option)"
                      (select$)="select(option)"
                    >
                    </app-monitoring-option-card>
                  }
                }
              </div>
              @if (step!.stepSelectionType === StepSelectionType.PICK0TO1) {
                <app-reset-button class="odx-margin-top-8" (resetButtonClicked)="resetSingleSelection()"></app-reset-button>
              }
            </odx-radio-group>
          </form>
        } @else {
          <app-refresh-products-hint [dataType]="refreshProductsDataType"></app-refresh-products-hint>
        }
      }
    }
  </odx-content-box>
</div>
